import React, { Component, PropTypes } from "react";
import { Carousel as BootstrapCarousel } from "react-bootstrap";
import imagePromise from "image-promise";

export default class Carousel extends Component {
  mounted = false;
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        alt: PropTypes.string,
        image: PropTypes.string.isRequired,
        captions: PropTypes.any
      })
    ).isRequired,
    ...BootstrapCarousel.propTypes
  };

  static defaultProps = {
    controls: false
  };

  constructor(props) {
    super(props);
    this.state = {
      items: [
        {
          alt: "loader",
          image: ""
        }
      ],
      loaded: false,
      mounted: false
    };
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    const { items } = this.props;
    const newItems = [];
    const promises = [];

    const loadImages = (item, index) => {
      promises.push(
        imagePromise(item.image).then(img => {
          newItems[index] = { ...item };
        })
      );
    };
    for (let i in items) {
      loadImages(items[i], i);
    }

    Promise.all(promises)
      .then(() => {
        if (this.mounted === true) {
          this.setState({ items: newItems });
          this.setState({ loaded: true });
        }
      })
      .catch(e => console.log(e));
  }

  render() {
    // eslint-disable-next-line
    let { items, ...props } = this.props;

    return this.state.loaded &&
      <BootstrapCarousel {...props}>
        {this.state.items.map((item, id) => (
          <BootstrapCarousel.Item key={id}>
            <img width="100%" alt={item.alt} src={item.image} />
            {item.captions &&
              <BootstrapCarousel.Caption>
                {item.captions}
              </BootstrapCarousel.Caption>}
          </BootstrapCarousel.Item>
        ))}
      </BootstrapCarousel>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Carousel.js